module.exports = __webpack_public_path__ + "img/eye.e89da994.svg";